import { render } from "./AdGroupsCard.vue?vue&type=template&id=3b49524e"
import script from "./AdGroupsCard.vue?vue&type=script&lang=js"
export * from "./AdGroupsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__